import React from 'react'
import { useState, useEffect } from 'react';
import ImageA from '../image/C83z2DmMj-2ok.jpg';
import ImageB from '../image//240_F_782734817_pcv8G1yJ5hWwAL0OsFRpZWTylWMFOQtJ.jpg';


const images = [ImageA, ImageB];

function Slider() {


  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className='new-slider-home'>
      <div className="slider-container px-0 ">
        <div
          className="slider-background"
          style={{ backgroundImage: `url(${images[currentIndex]})` }}
        >
          {/* <div className="container-fluid d-flex justify-content-center align-items-center text-white text-center slider-content" >
          <div>
            <h1 className='fw-bold bgslider-h1'>Evaporate Cooling Solutions</h1>
            <h5>Portable | Top Discharge | Ducted Direct | Indirect – Direct | Portable & Tent Cooling</h5>
            <button className="btn btn-lg rounded-0 slider-button mt-4">Learn More</button>
          </div>
        </div> */}
        </div>
      </div>
    </div>
  )
}

export default Slider
